import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubdomain } from "../utils/getSubdomain/subdomain";
import { AppDispatch, RootState } from "../app/store";
import { getAppLanguages } from "../features/app_language/app_languageSlice.ts";


export const useClient = () => {
    const clientSubdomain = getSubdomain();
    const dispatch = useDispatch<AppDispatch>();

    const publication = useSelector((state: RootState) => 
        state.admin?.publicationTheme ?? null
    );
    const magazineLoading = useSelector((state: RootState) => 
        state.admin?.magazineThemeLoading ?? false
    );
    const error = useSelector((state: RootState) => 
        state.admin?.themeError ?? null
    );



    useEffect(() => {
        if (clientSubdomain) {
            dispatch(getAppLanguages());
        }
    }, [clientSubdomain, dispatch]);
    
    const isValid = !magazineLoading && !error && publication !== null;

    return { 
        clientSubdomain, 
        clientData: publication, 
        isValid, 
        magazineLoading 
    };
};